import { FC } from "react";
import { AgendaItem } from "./AgendaItem";

interface Props {
  data: {
    title: string;
    introduction?: string;
    agendaItems: {
      subtitle: string;
      descriptions: string[];
      src?: string;
    }[];
  };
}

export const TOMProgram: FC<Props> = ({ data }) => {
  return (
    <>
      <h2 className="text-3xl md:text-4xl font-bold text-red-500 mx-6 mt-6 md:mt-10 mb-6">{data.title}</h2>
      <p className="text-lg mx-6 mb-6">{data.introduction}</p>
      {data.agendaItems.map((agendaItem, index) => (
        <div key={index}>
          <AgendaItem 
            subtitle={agendaItem.subtitle}
            descriptions={agendaItem.descriptions}
            src={agendaItem.src} 
          />
        </div>
      ))}
    </>
  );
};